<template>
  <div class="about">
    <a-spin tip="資料載入中..." :spinning="loading">
      <div class="container">
        <div class="query-card">
          <div class="query-title">統計查詢</div>
          <div class="query-row">
            <div class="query-field">
              <label>年份</label>
              <b-form-select v-model="selectedYear" class="field-select">
                <option v-for="y in yearList" :value="y" :key="y">{{ y }} 年</option>
              </b-form-select>
            </div>
            <div class="query-field">
              <label>月份</label>
              <b-form-select v-model="selectedMonth" class="field-select">
                <option :value="null">請選擇</option>
                <option v-for="m in 12" :value="m" :key="m">{{ m }} 月</option>
              </b-form-select>
            </div>
            <div class="query-field query-btn-wrap">
              <b-button variant="info" @click="query()" class="query-btn">
                <b-icon icon="search" /> 查詢
              </b-button>
            </div>
          </div>
        </div>
        <div class="result-area" v-if="queried">
          <div class="query-badge" v-if="queriedLabel">
            <span class="badge-icon">🔍</span>
            查詢條件：<strong>{{ queriedLabel }}</strong>
          </div>
          <div v-if="rsMyData.length === 0" class="no-data">
            查無資料
          </div>
          <Actstatistics v-if="rsMyData.length > 0" :myDate="rsMyData" ref="con2" />
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import Actstatistics from './panel/Actstatistics.vue'
import { reportService } from '../_services'
import 'moment/locale/zh-tw';

const queryMyData = params => {
  return reportService.getActShip(params)
};

export default {
  name: 'Actreportshipscore',
  components: {
    Actstatistics,
  },
  props: {
    msg: String
  },
  data() {
    const now = new Date()
    return {
      useid: 0,
      selectedYear: now.getFullYear(),
      selectedMonth: null,
      rsMyData: [],
      loading: false,
      queried: false,
      queriedLabel: '',
    };
  },
  computed: {
    ...mapState("account", ["status", "user", "linecheck"]),
    yearList() {
      const current = new Date().getFullYear()
      const years = []
      for (let y = current; y >= current - 3; y--) {
        years.push(y)
      }
      return years
    },
    defaultDate() {
      if (this.selectedMonth === null) {
        return `${this.selectedYear}`
      }
      const m = String(this.selectedMonth).padStart(2, '0')
      return `${this.selectedYear}-${m}`
    },
  },
  mounted() {
    if (this.user !== null) {
      this.useid = this.user.data.user.id
    }
  },
  methods: {
    query() {
      this.loading = true
      this.queried = false
      const monthStr = this.selectedMonth ? `${this.selectedMonth} 月` : '全年'
      this.queriedLabel = `${this.selectedYear} 年 ${monthStr}`
      queryMyData({
        date: this.defaultDate,
      }).then(({ data }) => {
        this.rsMyData = data.data
        this.queried = true
        this.loading = false
      }).catch(() => {
        this.rsMyData = []
        this.queried = true
        this.loading = false
      })
    },
  },
}
</script>
<style scoped>
.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 1rem;
}

.query-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 1.5rem;
}

.query-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1.2rem;
  padding-bottom: 0.6rem;
  border-bottom: 2px solid #17a2b8;
}

.query-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
}

.query-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.query-field label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 500;
  margin: 0;
}

.field-select {
  width: 130px;
  height: 2.2rem;
}

.query-btn-wrap {
  justify-content: flex-end;
}

.query-btn {
  height: 2.2rem;
  padding: 0 1.2rem;
  font-size: 0.95rem;
}

.result-area {
  padding: 0.5rem 0;
}

.query-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #e8f7fa;
  border: 1px solid #17a2b8;
  border-radius: 20px;
  padding: 0.35rem 1rem;
  font-size: 0.88rem;
  color: #0c7a8a;
  margin-bottom: 1rem;
}

.badge-icon {
  font-size: 0.9rem;
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 1rem;
  padding: 2rem 0;
}
</style>

